import React, { useEffect } from 'react'
import { FiAlertCircle, FiCheckCircle, FiInfo, FiXCircle } from 'react-icons/fi'

import { ToastMassege, useToast } from '../../../hooks/toast'
import { Container } from './styles'

interface ToastProps {
  message: ToastMassege
  style: object
}

const icons = {
  info: <FiInfo size={24} />,
  success: <FiCheckCircle size={24} />,
  error: <FiAlertCircle size={24} />
}

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast } = useToast()

  useEffect(() => {
    if (!message.timer) {
      const timer = setTimeout(() => {
        removeToast(message.id)
      }, 6000)

      return () => {
        clearTimeout(timer)
      }
    }
    
  }, [removeToast, message.id])

  return (
    <Container
      hasDescription={!!message.description}
      type={message.type}
      style={style}
    >
      {icons[message.type || 'info']}

      <div className="content">
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}

        {message?.actions && message.actions?.length > 0 && (
          <div className="toast-actions">
            {message.actions.map((action, index) => (
              <button
                key={index}
                onClick={() => {
                  action.onClick()
                  removeToast(message.id) // Remove toast ao clicar (opcional)
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <button
        className="close-button"
        onClick={() => removeToast(message.id)}
        type="button"
      >
        <FiXCircle size={18} />
      </button>
    </Container>
  )
}

export default Toast